module.exports = __webpack_public_path__ + "build/img/summer3.cbc4b3ba.png";